import { createSlice } from "@reduxjs/toolkit";
import { abandonedCartPreference } from "./abandoned-cart-preference.thunks";
import { ActionStatus } from "../../common/constants/action-status";
import { defaultApiState } from "../../common/constants/api-constants";

/*----- CREATE INITIAL STATE ------*/
export const abandonedCartPreferenceState = {
  ...defaultApiState,
  data: {
    status: ''
  }
}

/*----- CREATE STORE SLICE ------*/

export const abandonedCartPreferenceSlice = createSlice({
  name: "abandonedCartPreference",
  initialState: abandonedCartPreferenceState,
  reducers:{},
  extraReducers(builder) {
    builder
    .addCase(abandonedCartPreference.pending, (state) => {
      state.status = ActionStatus.loading
    })
    .addCase(abandonedCartPreference.fulfilled, (state, action) => {
      state.status = ActionStatus.succeeded
      state.data = action.payload;
    })
    .addCase(abandonedCartPreference.rejected, (state, action) => {
      state.status = ActionStatus.failed
      state.error = action.error.message || ''
    })
  }
});

/*----- CREATE REDUCER ------*/

export const abandonedCartPreferenceReducer = abandonedCartPreferenceSlice.reducer;
